// WHAT CAN BE CHANGED?
// Put the desired content into the #home-div

<template>
    <div id="missed" class="page">
        <div id="missed__video-player"></div>
        <ContentHeader headerTitle="Gemist" />
        <YoutubeAPI />
    </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader";
import YoutubeAPI from '../components/YoutubeAPI.vue';

export default {
    name: "Missed",
    components: {
        ContentHeader,
        YoutubeAPI
    },
    props: {  
    }
};
</script>

<style lang="scss">
#missed {
  margin: auto;
  max-width: 768px;

  #missed__video-player {
    max-width: 768px;
    margin: auto;
    margin-bottom: 16px;
    position: relative;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-width: 0px;
    }
  }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #missed {
      margin: 0px 16px;
      #missed__video-player {
        margin: 0px -16px 16px -16px;
      }
    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #missed {
      margin: 0px 16px;
    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #missed {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #missed {
    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #missed {
    }
}
</style>